import * as React from "react";

import { ViewportContext, ViewportState } from "./ViewportContext";

export function useViewport(): ViewportState {
  return React.useContext(ViewportContext);
}
